import React from 'react';

const Header = () => null

export default Header